const storageKey = canvasId => `xiaoying:canvas-script-breakdown:${canvasId}`;
const fallback = new Map();

export function mergeProductionDirectives(current = {}, changes = {}) {
  const next = { ...current, ...changes };
  if (changes.target_seconds) { delete next.target_seconds_min; delete next.target_seconds_max; }
  if (changes.production_medium && (current.production_medium || current.art_style) && changes.production_medium !== current.production_medium && !changes.art_style) {
    const styles = { anime_2d: ['anime_2d', '2D 动画'], cgi_3d: ['guoman_cg', '3D 动画'], live_action: ['custom', '真人实拍'], ai_photoreal: ['custom', 'AI 写实'], hybrid: ['custom', '真人与动画混合'] };
    const selected = styles[changes.production_medium];
    if (selected) {
      next.art_style = selected[0];
      if (!changes.visual_style && (!current.visual_style || /2D|3D|二维|三维|动画|真人|AI写实/i.test(current.visual_style))) next.visual_style = selected[1];
    }
  }
  return next;
}

// This is a navigation/recovery receipt, not a second copy of the script or run.
export function readScriptBreakdown(canvasId) {
  try {
    const value = JSON.parse(sessionStorage.getItem(storageKey(canvasId)) || 'null');
    return value?.canvasId === canvasId && value?.idempotencyKey ? value : null;
  } catch { return fallback.get(canvasId) || null; }
}

export function saveScriptBreakdown(record) {
  fallback.set(record.canvasId, record);
  try { sessionStorage.setItem(storageKey(record.canvasId), JSON.stringify(record)); } catch { /* Same-tab navigation can still use memory. */ }
  return record;
}

export function queueScriptBreakdown(canvasId) {
  return saveScriptBreakdown({ canvasId, idempotencyKey: `canvas-${canvasId}-script-breakdown`, phase: 'pending', runId: null });
}

export function clearScriptBreakdown(canvasId) {
  fallback.delete(canvasId);
  try { sessionStorage.removeItem(storageKey(canvasId)); } catch { /* Memory was cleared above. */ }
}

export function writingHandoffMessage(handoff) {
  if (!String(handoff?.data?.content || '').trim()) return '';
  return [handoff.data.content, handoff.data.production_context
    && `【制作参考资料，仅用于理解背景与人物外形，不新增剧情或对白】\n${handoff.data.production_context}`].filter(Boolean).join('\n\n');
}
